export const trackFa = (event: any) => {
  if (window && window.__fa) {
    window.__fa.push(['trackEvent', event]);
  }
};
